import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import {
  formatMoneda, validaMonto, formatoMonto
} from '../../../util/varios';
import { Mensaje } from '../../mensajes';

import { Dimmer } from "../../spinner";



export const AgregarDescuento = (props) => {

    const btnAcepta = useRef();
    const btnCancela = useRef();
    const txtValor = useRef();
    const diaDesde = useRef();
    const mesDesde = useRef();
    const diaHasta = useRef();
    const mesHasta = useRef();

    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar, setMostrar] = useState(false);
    const [activate, setActivate] = useState(false);

    const blanquear = () => {

        setMostrar(false);
        setTitulo('');
        setMsg('');
        setActivate(false);
    };

    const handleValidarDia = (event) => {

        if (event.target.name === "diaDesde") {

            if (diaDesde.current.value > '29' && mesDesde.current.value === '2') {

                setTitulo("Información");
                setMsg("Día Invalido");
                setMostrar(true);
                diaDesde.current.value = '01';
                diaDesde.current.focus();

            } else if (diaDesde.current.value === '31' && mesDesde.current.value === '11') {

                setTitulo("Información");
                setMsg("Día Invalido");
                setMostrar(true);
                diaDesde.current.value = '01';
                diaDesde.current.focus();
            }

        } else if (event.target.name === "diaHasta") {

            if (diaHasta.current.value > '29'  && mesHasta.current.value === '2') {

                setTitulo("Información");
                setMsg("Día Invalido");
                setMostrar(true);
                diaHasta.current.value = '01';
                diaHasta.current.focus();

            } else  if (diaHasta.current.value > '31' && mesDesde.current.value === '11') {

                setTitulo("Información");
                setMsg("Día Invalido");
                setMostrar(true);
                diaHasta.current.value = '01';
                diaHasta.current.focus();

            }

        } 

    }


    const handleValidarFecha = (event) => {

        switch (event.target.value) {
            case '02':
                if (event.target.name === "mesDesde") {

                    if (diaDesde.current.value > '29') {

                        setTitulo("Información");
                        setMsg("Día Invalido");
                        setMostrar(true);
                        diaDesde.current.value = '01';
                        diaDesde.current.focus();
                    }

                } else if (event.target.name === "mesHasta") {

                    if (diaHasta.current.value > '29') {

                        setTitulo("Información");
                        setMsg("Día Invalido");
                        setMostrar(true);
                        diaHasta.current.value = '01';
                        diaHasta.current.focus();
                    }

                }

                break;
            case '04':
            case '06':
            case '09':
            case '11':

                if (event.target.name === "mesDesde") {

                    if (diaDesde.current.value === '31') {

                        setTitulo("Información");
                        setMsg("Día Invalido");
                        setMostrar(true);
                        diaDesde.current.value = '01';
                        diaDesde.current.focus();
                    }

                } else if (event.target.name === "mesHasta") {

                    if (diaHasta.current.value > '31') {

                        setTitulo("Información");
                        setMsg("Día Invalido");
                        setMostrar(true);
                        diaHasta.current.value = '01';
                        diaHasta.current.focus();
                    }

                }

                break;

        }
    };

    const handleInputMontoChange = (event) => {
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which >= 37 && event.which <= 40) {
            event.preventDefault();
        }
    
    
        // Devuelve el número formateado
        let e = event.target.value.replace(/\D/g, "")
            .replace(/([0-9])([0-9]{2})$/, '$1.$2')
            .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");
    
            return formatMoneda(e)
    };


    const handleCloseMensa = () => {

        setMostrar(false);

        if (msg === "La tabla fue actualizada") {

            cancelar();
        }
    };

    const cancelar = () => {

        blanquear();
        props.onHideCancela();

    };

    const aceptar = () => {

        var ini = diaDesde.current.value + '/' + mesDesde.current.value;
        var fin = diaHasta.current.value + '/' + mesHasta.current.value;
        var porce = txtValor.current.value;

        if(ini.localeCompare(fin)>0){

            setTitulo("Información");
			setMsg("El Periodo Desde debe ser menor que el Periodo Hasta");
            setMostrar(true);
			diaDesde.current.focus();

		} else if(txtValor.current.value === ""){

            setTitulo("Información");
			setMsg("El valor no debe estar en blanco ");
            setMostrar(true);
			txtValor.current.focus();

		} else if (txtValor.current.value.trim() === "0,00") {

            setTitulo("Información");
			setMsg("El valor no debe ser cero");
            setMostrar(true);
			txtValor.current.focus();

		} else {

            props.onHideAcepta(ini, fin, porce);
            setTitulo("Información");
            setMsg("La tabla fue actualizada");
            setMostrar(true);

        }

    };

    const editar = (descuento) => {

        diaDesde.current.value = descuento.periodoini.toString().substring(0, 2);
        mesDesde.current.value = descuento.periodoini.toString().substring(3, 5);
        diaHasta.current.value = descuento.periodofin.toString().substring(0, 2);
        mesHasta.current.value = descuento.periodofin.toString().substring(3, 5);
        txtValor.current.value = formatMoneda(descuento.porcentaje.toString().replace('.', ','), ',', '.', 2);

    };

    return (
        <Modal
            {...props}
            size="md"
            style={{backgroundColor:"rgb(0,0,0,0.3)"}}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {

                if (props.tipoconf === 2) {
                    editar(props.descuento);
                }

            }}

        >
            <Mensaje titulo={titulo} mensaje={msg}
                show={mostrar}
                onHide={handleCloseMensa} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
            <Modal.Header className='azulty' style={{ height: '40px' }}>
                <div style={{ color: "#fff", fontFamily: 'Times New Roman, Times, serif', fontSize: 20 }}>{props.tipoconf === 1 ? 'Agregar Descuento' : props.tipoconf === 2 ? 'Editar Descuento' : 'Eliminar Descuento'}</div>            
                <button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body >

                <div className="col-md-12">
                    <div className="row border border-info rounded">
                        <div className="form-row col-md-12">
                            <div className="form-row" >
                                <div className="col-md-2">
                                    <label htmlFor="diaDesde">Día Desde </label>
                                    <select name="diaDesde" style={{ textAlign: "right" }} onKeyUp={handleValidarDia} onBlur={handleValidarDia} ref={diaDesde} className="form-control form-control-sm col-md-10" >
                                        <option value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>
                                        <option value="21">21</option>
                                        <option value="22">22</option>
                                        <option value="23">23</option>
                                        <option value="24">24</option>
                                        <option value="25">25</option>
                                        <option value="26">26</option>
                                        <option value="27">27</option>
                                        <option value="28">28</option>
                                        <option value="29">29</option>
                                        <option value="30">30</option>
                                        <option value="31">31</option>
                                    </select>
                                </div>
                                <div className="col-md-2 border">
                                    <label htmlFor="mesDesde">Mes Desde </label>
                                    <select name="mesDesde" style={{ textAlign: "right" }} onKeyUp={handleValidarFecha} onBlur={handleValidarFecha} ref={mesDesde} className="form-control form-control-sm col-md-10" >
                                        <option value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                </div>
                                <div className="col-md-2 border">
                                    <label htmlFor="diaHasta">Día Hasta </label>
                                    <select name="diaHasta" style={{ textAlign: "right" }} onKeyUp={handleValidarDia} onBlur={handleValidarDia} ref={diaHasta} className="form-control form-control-sm col-md-10" >
                                        <option value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>
                                        <option value="21">21</option>
                                        <option value="22">22</option>
                                        <option value="23">23</option>
                                        <option value="24">24</option>
                                        <option value="25">25</option>
                                        <option value="26">26</option>
                                        <option value="27">27</option>
                                        <option value="28">28</option>
                                        <option value="29">29</option>
                                        <option value="30">30</option>
                                        <option value="31">31</option>
                                    </select>
                                </div>
                                <div className="col-md-2 border">
                                    <label htmlFor="mesHasta">Mes Hasta </label>
                                    <select name="mesHasta" style={{ textAlign: "right" }} onKeyUp={handleValidarFecha} onBlur={handleValidarFecha} ref={mesHasta} className="form-control form-control-sm col-md-10" >
                                        <option value="01">01</option>
                                        <option value="02">02</option>
                                        <option value="03">03</option>
                                        <option value="04">04</option>
                                        <option value="05">05</option>
                                        <option value="06">06</option>
                                        <option value="07">07</option>
                                        <option value="08">08</option>
                                        <option value="09">09</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor="txtValor">Valor del Descuento </label>
                                    <input type="text" ref={txtValor} onKeyUp={handleInputMontoChange} onBlur={handleInputMontoChange} defaultValue="0,00" id="txtValor" style={{ textAlign: "right" }} className="form-control form-control-sm col-md-12" />
                                </div>
                            </div>
                        </div>


                    </div>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} onClick={aceptar} className="btn btn-sm btn-success rounded-pill"><i className="fas fa-plus"> Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}